import { z } from 'zod';

import { Box, Form } from '@ekhodealer/ekho-common/rev';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
// eslint-disable-next-line no-restricted-imports -- intentional cross-feature: CRM is a shared concern
import { useGetAiBdcSettings } from '@features/ai-bdc/api/useGetAiBdcSettings';
// eslint-disable-next-line no-restricted-imports -- intentional cross-feature: CRM is a shared concern
import { useUpdateAiBdcSettings } from '@features/ai-bdc/api/useUpdateAiBdcSettings';

const crmSchema = z.object({
	crmEmail: z.string().email('Please enter a valid email address').optional().or(z.literal('')),
});

export function CrmForwardingSection(): React.JSX.Element {
	const spId = useCurrentServicesProviderId();
	const { data: settings } = useGetAiBdcSettings(spId);
	const updateMutation = useUpdateAiBdcSettings(spId);

	const handleSubmit = async (
		data: z.infer<typeof crmSchema>,
	): Promise<{ isSuccess: boolean }> => {
		try {
			await updateMutation.mutateAsync({
				crmEmail: data.crmEmail || undefined,
			});
			return { isSuccess: true };
		} catch {
			return { isSuccess: false };
		}
	};

	return (
		<Box padding='24' background='secondary' rounding='12'>
			<Form
				name='integrations-crm-forwarding'
				schema={crmSchema}
				defaultValues={{ crmEmail: settings?.crmEmail ?? '' }}
				onSubmit={handleSubmit}
				showSaveAndClear
				title='CRM forwarding'
				titleLevel='subgroup'
				titleWeight='semibold'
				description='Forward captured lead data to your CRM via ADF/XML email. Leave blank to disable forwarding.'>
				<Form.Field.Text
					schemaField='crmEmail'
					labelText='CRM email address'
					type='email'
					size='large'
					placeholder='crm-intake@dealer.com'
				/>
			</Form>
		</Box>
	);
}
